module.exports = __webpack_public_path__ + "img/难过.084b0a7f.png";